import { IconConfig } from "../types";

export const arrowRightLeft:IconConfig =  {
  type: 'stroke' as const,
  viewBox: "0 0 24 24",
  paths: [
    "m16 3 4 4-4 4",
    "M20 7H4",
    "m8 21-4-4 4-4",
    "M4 17h16"
  ]
}
